import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

export const CustomConfirmDialog = ({ title, message, onConfirm, onCancel }) => {
  return (
    <div className='custom-ui mx-2'>
      <h3 className='custom-title'>{title}</h3>
      <p className='custom-message'>{message}</p>
      <button onClick={onConfirm}>Yes</button>
      <button onClick={onCancel}>No</button>
    </div>
  );
};

// const showDialog = () => {
//   confirmAlert({
//     customUI: ({ onClose }) => {
//       return (
//         <CustomConfirmDialog
//           title='Are you sure?'
//           message='You want to delete this file?'
//           onConfirm={() => {
//             onClose();
//             // Handle confirm action
//           }}
//           onCancel={onClose}
//         />
//       );
//     },
//   });
// };

// const App = () => {
//   return (
//     <div>
//       <button onClick={showDialog}>Show Confirm Dialog</button>
//     </div>
//   );
// };
